import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AngularFirestoreCollection, AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-simcards',
  templateUrl: './simcards.component.html',
  styleUrls: ['./simcards.component.scss']
})
export class SimcardsComponent implements AfterViewInit {

  private itemsCol:    AngularFirestoreCollection<any>;
  public  items:       Observable<any>;
  public  dataSource = new MatTableDataSource<any>();

  public displayedColumns = ["id", "tipo", "nroTelefono", "fechaRecepcion", "fechaActivacion", "fechaLegalizacion", "fechaVenta", "puntoVenta", "vendedor", "mes1", "mes2", "mes3", "mes4", "mes5", "mes6", "total"/*, "options"*/ ];
  
  @ViewChild(MatSort, {static: true}) sort: MatSort;  
  filter: string = "";
  tipoFiltro: string = "id";

  private suscription = null;
  public filename:string="simcards";
  public isLoading:boolean = false;
  public fnExportSimcards: (data: any) => Observable<any>;

  constructor(private afFunctions: AngularFireFunctions, private afFirestore: AngularFirestore,private snackBar: MatSnackBar, public authService: AuthService) {    
    this.itemsCol = afFirestore.collection<any>("simcard", ref=>ref.limit(100));
    this.items    = this.itemsCol.valueChanges();
    this.fnExportSimcards  = this.afFunctions.httpsCallable('fileExports1-exportSimcards', {timeout: 180000});
  }

  ngAfterViewInit() {        
    this.suscription = this.items.subscribe(
      data => {
        console.log("Data length: "+data.length);
        this.dataSource = new MatTableDataSource<any>(data);        
        this.dataSource.sort      = this.sort;
        this.dataSource.filter    = this.filter;         
      }
    );
  }

  trackByUid(index, item) {
    return item.uid;
  }

  getTotalRecargas(simcard){
    let total = 0;
    if( simcard["recargas"] !== undefined ){
        let recargas: number[] = simcard["recargas"];
        for( let i = 0; i < recargas.length; i++ ){
            total += recargas[i];            
        }
    }
    return total;
  }

  applyFilter() {    
    this.filter = this.filter.trim().toLowerCase();
    console.log("applyFilter("+this.tipoFiltro+","+this.filter+")");
    if( this.filter.length > 0 ){      
      if( this.tipoFiltro === "tropa" || this.tipoFiltro === "puntoVenta" || this.tipoFiltro === "vendedor" ){
        
        this.itemsCol = this.afFirestore.collection<any>("simcard", 
          ref => ref.where(this.tipoFiltro, '==', this.filter).limit(1000)
        );
        //this.filename = ("simcards_"+this.tipoFiltro+"_"+this.filter).toLowerCase();
      }
      else{
        this.itemsCol = this.afFirestore.collection<any>("simcard", 
          ref => ref.where(this.tipoFiltro, '>=', this.filter)
            .where(this.tipoFiltro, '<=', this.filter+'\uf8ff')
            .limit(1000)
        );
        //this.filename = ("simcards_"+this.tipoFiltro+"_"+this.filter+"_100").toLowerCase();
      }      
    }
    else{
      this.itemsCol = this.afFirestore.collection<any>("simcard", ref=>ref.limit(100));
      this.filename = ("simcards_100").toLowerCase();
    }    
    this.isLoading = true;    
    this.items  = this.itemsCol.valueChanges();
    this.suscription.unsubscribe();
    this.suscription = this.items.subscribe(
      data => {
        console.log("Data length: "+data.length);
        this.dataSource = new MatTableDataSource<any>(data);        
        this.dataSource.sort      = this.sort;
        this.dataSource.filter    = this.filter; 
        this.isLoading = false;
      }
    );
  }

  createFile(){
    this.isLoading = true;
    this.fnExportSimcards({tipoFiltro: this.tipoFiltro, valueFiltro: this.filter}).toPromise()
    .then(
      (url:string) => {        
        console.log(url); 
        this.filename = url;
        this.isLoading = false;   
        window.open(url, "_blank");
      }
    )
    .catch(
      (fnError) => {        
        this.isLoading = false;
        this.snackBar.open("Error inesperado descargando el archivo, intente nuevamente","Entiendo",{duration: 2000});
      }
    );
  }  

}
